import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { createSecureDownloadLink, getCleanFileName } from "../../../../../utils/DocumentAccessControl";

/** TaskDetail ile aynı anahtar (custom upload Value ↔ dosya adı eşlemesi) */
const normalizeFileKey = (v = "") =>
    decodeURIComponent(String(v))
        .toLowerCase()
        .replace(/[\s_-]/g, "")
        .replace(/ı/g, "i")
        .replace(/ğ/g, "g")
        .replace(/ü/g, "u")
        .replace(/ş/g, "s")
        .replace(/ö/g, "o")
        .replace(/ç/g, "c");

const UUID_RE =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const safeDecode = (v = "") => {
    try {
        return decodeURIComponent(String(v));
    } catch (e) {
        return String(v);
    }
};

const toBaseName = (v = "") => {
    const s = String(v);
    const parts = s.split(/[\\/]/);
    return parts[parts.length - 1] || s;
};

/**
 * API bazen CustomValue.Path boş döner; Value ise dosya adı veya guid olabilir.
 * Talep belgeleri listesindeki Document.FilePath ile eşleştiririz.
 */
function resolveCustomUploadFilePath(item, taskDocuments) {
    if (item.Path) return item.Path;
    if (!taskDocuments || !Array.isArray(taskDocuments)) return null;
    const rawValue = String(item.Value ?? "").trim();
    const rawFileName = String(item.FileName ?? "").trim();
    const candidates = [rawValue, rawFileName]
        .filter((x) => !!x)
        .map((x) => safeDecode(x));

    if (candidates.length === 0) return null;

    const normCandidates = [];
    candidates.forEach((candidate) => {
        const baseName = toBaseName(candidate);
        normCandidates.push(normalizeFileKey(candidate));
        normCandidates.push(normalizeFileKey(baseName));
        // GUID_gercekDosya.ext formatları için gerçek dosya adını da aday yap.
        if (baseName.includes("_")) {
            const trimmed = baseName.split("_").slice(1).join("_");
            if (trimmed) {
                normCandidates.push(normalizeFileKey(trimmed));
            }
        }
    });

    for (const td of taskDocuments) {
        const fp = td?.Document?.FilePath;
        if (!fp) continue;
        const clean = getCleanFileName(fp);
        if (clean === "Erişim süresi geçmiştir") continue;
        const normalizedClean = normalizeFileKey(clean);
        const normalizedFp = normalizeFileKey(fp);

        if (normCandidates.some((x) => x && x === normalizedClean)) return fp;
        if (normCandidates.some((x) => x && normalizedFp.includes(x))) return fp;
        if (UUID_RE.test(rawValue) && fp.includes(rawValue)) return fp;
    }
    return null;
}

const ExtraInfoModal = ({ open, onClose, data = [], taskDocuments = [] }) => {
    const DATE_OPTIONS = { year: "numeric", month: "2-digit", day: "2-digit" };

    return (
        <Modal
            isOpen={open}
            toggle={onClose}
            size="md"
            centered
            contentClassName="extra-info-modal"
        >
            {/* Header */}
            <ModalHeader
                toggle={onClose}
                style={{
                    backgroundColor: "#ffc107",
                    color: "#333",
                    fontWeight: 700,
                    borderBottom: "3px solid rgba(0,0,0,0.1)",
                    borderRadius: "0 0 0 0"
                }}
            >
                Talebe İlişkin Özel Alanlar
            </ModalHeader>

            {/* Body */}
            <ModalBody style={{ padding: "24px" }}>
                <p
                    style={{
                        marginTop: "-6px",
                        marginBottom: "16px",
                        color: "#6c757d",
                        fontSize: "0.9rem"
                    }}
                >
                    Talep Detayları
                </p>

                <div
                    style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                    }}
                >
                    <table className="table mb-0">
                        <thead>
                            <tr style={{ backgroundColor: "#fff8e1" }}>
                                <th style={{ fontWeight: 700 }}>Alan</th>
                                <th style={{ fontWeight: 700 }}>Değer</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.map((item, i) => {
                                const type = item.CategoryCustomControl.CustomControlType;
                                const label = item.CategoryCustomControl.Value;

                                return (
                                    <tr key={i}>
                                        <td
                                            style={{
                                                width: "40%",
                                                fontWeight: 600,
                                                color: "#555",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                overflowWrap: "break-word"
                                            }}
                                        >
                                            {label}
                                        </td>

                                        <td style={{ width: "60%", color: "#333" }}>
                                            {type === 2 ? (
                                                createSecureDownloadLink(
                                                    {
                                                        FilePath: resolveCustomUploadFilePath(
                                                            item,
                                                            taskDocuments
                                                        )
                                                    },
                                                    item.FileName || item.Value,
                                                    {
                                                        style: {
                                                            color: "#007bff",
                                                            cursor: "pointer",
                                                            textDecoration: "underline"
                                                        }
                                                    },
                                                    item.Value
                                                )
                                            ) : type === 1 ? (
                                                new Date(item.Value).toLocaleDateString(
                                                    "tr-TR",
                                                    DATE_OPTIONS
                                                )
                                            ) : (
                                                item.Value
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

            </ModalBody>
        </Modal>
    );
};

export default ExtraInfoModal;
